export default function TopBanner() {
  return (
    <div className="bg-[#0077B6] py-3">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-center gap-3 text-white">
          <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
            <i className="ri-phone-fill text-white text-base"></i>
          </div>
          <p className="text-sm font-semibold">
            Call in today - Now doing Healthcare coverage calls
          </p>
          <a 
            href="tel:830-203-6201" 
            className="ml-2 px-4 py-1.5 bg-white text-[#0077B6] text-sm font-bold rounded-full hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap"
          >
            830-203-6201
          </a>
        </div>
      </div>
    </div>
  );
}
